var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.imageUrl !== null)?_c('img',{staticClass:"fapi-item-image",staticStyle:{"max-width":"250px","max-height":"150px","border-radius":"5px"},attrs:{"src":_vm.imageUrl}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }